// SPDX-License-Identifier: AGPL-3.0-only
// GENERATED by scripts/gen-icon-core.mjs — do not edit.
//
// The lucide icons this product renders, as NAMED imports so a bundler can
// shake the other ~1,520. Importing lucide's `icons` map instead put all 1,611
// into the dashboard's entry chunk: 112.6 KiB gzipped, measured, for these 126.
//
// An icon outside this set still resolves — `icon-resolver.ts` loads the full
// catalogue on demand — it just costs a chunk fetch the first time.
import { Activity, Archive, ArrowLeft, ArrowRight, Banknote, Bell, BookOpen, Box, Briefcase, Bug, Building, Building2, Calendar, CalendarClock, CalendarDays, Camera, ChartBar, ChartColumn, ChartLine, ChartPie, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, CircleCheck, ClipboardList, Clock, Cloud, Columns3, Contact, CornerDownLeft, CornerUpLeft, Cpu, CreditCard, Database, Download, Factory, File, FileText, Files, Flag, Folder, Gauge, Gift, GitBranch, GitFork, Globe, Grid2x2, Handshake, HardDrive, Heart, House, IdCard, Image, Inbox, Info, Kanban, Key, KeyRound, Layers, LayoutDashboard, LayoutGrid, LayoutList, LayoutTemplate, Library, LifeBuoy, Lightbulb, Link, List, ListChecks, Lock, LogIn, LogOut, Mail, Map, MapPin, Megaphone, MessageSquare, MessageSquareText, Milestone, Music, Package, Paperclip, Percent, Phone, Plane, Plus, Receipt, Redo2, Rows3, ScrollText, Send, Server, Settings, Shapes, Shield, Ship, ShoppingBag, ShoppingCart, SlidersHorizontal, Sparkles, SquareKanban, Star, Store, Table, Table2, Tag, Tags, Target, Terminal, Timer, TrendingUp, Truck, Undo2, Upload, User, UserCheck, UserPlus, UserRound, Users, Video, Wallet, Warehouse, Wrench, Zap, } from 'lucide-react';
export const CORE_ICONS = {
    Activity,
    Archive,
    ArrowLeft,
    ArrowRight,
    Banknote,
    Bell,
    BookOpen,
    Box,
    Briefcase,
    Bug,
    Building,
    Building2,
    Calendar,
    CalendarClock,
    CalendarDays,
    Camera,
    ChartBar,
    ChartColumn,
    ChartLine,
    ChartPie,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleCheck,
    ClipboardList,
    Clock,
    Cloud,
    Columns3,
    Contact,
    CornerDownLeft,
    CornerUpLeft,
    Cpu,
    CreditCard,
    Database,
    Download,
    Factory,
    File,
    FileText,
    Files,
    Flag,
    Folder,
    Gauge,
    Gift,
    GitBranch,
    GitFork,
    Globe,
    Grid2x2,
    Handshake,
    HardDrive,
    Heart,
    House,
    IdCard,
    Image,
    Inbox,
    Info,
    Kanban,
    Key,
    KeyRound,
    Layers,
    LayoutDashboard,
    LayoutGrid,
    LayoutList,
    LayoutTemplate,
    Library,
    LifeBuoy,
    Lightbulb,
    Link,
    List,
    ListChecks,
    Lock,
    LogIn,
    LogOut,
    Mail,
    Map,
    MapPin,
    Megaphone,
    MessageSquare,
    MessageSquareText,
    Milestone,
    Music,
    Package,
    Paperclip,
    Percent,
    Phone,
    Plane,
    Plus,
    Receipt,
    Redo2,
    Rows3,
    ScrollText,
    Send,
    Server,
    Settings,
    Shapes,
    Shield,
    Ship,
    ShoppingBag,
    ShoppingCart,
    SlidersHorizontal,
    Sparkles,
    SquareKanban,
    Star,
    Store,
    Table,
    Table2,
    Tag,
    Tags,
    Target,
    Terminal,
    Timer,
    TrendingUp,
    Truck,
    Undo2,
    Upload,
    User,
    UserCheck,
    UserPlus,
    UserRound,
    Users,
    Video,
    Wallet,
    Warehouse,
    Wrench,
    Zap,
};
//# sourceMappingURL=icon-core.js.map